import QueryString from 'qs'

export const toQuery = (qObj: Record<string, string | number | undefined>) =>
  QueryString.stringify(qObj, {
    filter: (_, value) => (typeof value !== 'undefined' && value !== '' ? value : undefined),
  })
